import { render } from "./Donnees.vue?vue&type=template&id=4b0b20cc&scoped=true"
import script from "./Donnees.vue?vue&type=script&lang=js"
export * from "./Donnees.vue?vue&type=script&lang=js"

import "./Donnees.vue?vue&type=style&index=0&id=4b0b20cc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0b20cc"]])

export default __exports__